import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { merge, Observable, of } from 'rxjs';
import { delay, map, switchMap } from 'rxjs/operators';
import { IDataTableRowActionClickArg } from 'src/app/share/components/data-table-card/data-table-card.component';
import { IViewData } from 'src/app/share/entities/view-model';
import { FormAutoCompleteComponent, IFormAutoCompleteViewModel } from 'src/app/share/forms/form-auto-complete/form-auto-complete.component';
import { FormInputComponent, IFormInputViewModel } from 'src/app/share/forms/form-input/form-input.component';
import { FormOkCancelComponent } from 'src/app/share/forms/form-ok-cancel/form-ok-cancel.component';
import { BasePageComponent, IBasePageOnInitArg, IDataPanelTabViewModel, IWorkflowCompleteFormViewModel } from 'src/app/share/pages/base-page.component';
import { IPageContentFormViewModel, IPageContentViewModel, IPageDataViewModel, IPageViewModel } from 'src/app/share/pages/pages';
import { CommonService } from 'src/app/share/services/common.service';
import { ShellService } from 'src/app/shell/shell.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';

@Component({
  templateUrl: './vehicle-request-page.component.html',
  styleUrls: ['./vehicle-request-page.component.scss']
})
export class VehicleRequestPageComponent extends BasePageComponent implements OnInit {

  private readonly apiPath: string = '/api/reservations';

  /**
   * 
   */
  constructor(private apiService: CommonService, protected shellService: ShellService, protected activatedRate: ActivatedRoute) {
    super(shellService, activatedRate);
  }


  /**
   * 
   * @param action 
   * @param paramData 
   * @returns 
   */
  private vehicleRequestCommandInvoke(action: string, paramData): Observable<IPageDataViewModel> {
    return this.apiService.getData('PageCommand', 'vehicle-request', action, paramData, this.apiPath, true);
  }


  /**
   * just testing it out for now
   * 
   * @param vm 
   */
  onPageAddNew(pvm: IPageViewModel, vm: IContentViewModel) {
    this.requestFormStart(pvm, vm);
  }

  /**
   * 
   * @returns 
   */
  private testData(): IVehicleRequestData {

    var pickupDate = moment(new Date()).add(5, 'days').format('YYYY-MM-DD');

    return !environment.name ? {} : {
      customerCode: '2700',
      serviceArea: 'US-NYC',
      vehicleType: 'sdn',
      passengerCode: 'testpax',

      pickupLocation: '123 E Broadway, New York, NY 10002',
      dropLocation: 'ewr',

      pickupDate: pickupDate,
      pickupTime: '19:17',

      bookerName: 'Tom Smith',
      bookerPhone: '123-456-7890',

      comments: 'some comments'
    };
  }

  //#region detail form

  /**
   * call when single item is clicked in template
   * 
   * @param pvm 
   * @param vm 
   * @param rowId 
   */
  private async detailFormStart(pvm: IPageViewModel, vm: IContentViewModel, itemCode: string) {
    const fvm = super.formBegin(pvm, this.detailFormVm(vm));

    await super.formLoadAsync(fvm, () => {
      return of({}).pipe(
        delay(2000) /* simulate work, don't use for real.. Maybe load specific data for form  */,

        map(ctx => {
          const data = {
            entry: ''
          };

          fvm.entryVm = {
            data: {},
            entryInputVm: FormInputComponent.viewModel(data, 'entry',
              { title: 'Entry', isRequired: true }),
          }
        })
      );
    });
  }

  /**
   * 
   * @param code 
   */
  detailFormVm(vm: IContentViewModel): IDetailFormViewModel {
    const ret: IDetailFormViewModel = {
      ...super.formVm('vehicle-request-detail', { okCancelOptions: {} }),

      title: 'some detail entry form'
    };
    return ret;
  }

  //#endregion detail form

  //#region  request form

  /**
   * 
   */
  private async requestFormStart(pvm: IPageViewModel, vm: IContentViewModel) {
    const fvm = super.formBegin(pvm, this.requestFormVm(vm));

    await super.formLoadAsync(fvm, () => {
      return of({}).pipe(
        delay(500) /* simulate work, don't use for real */
      );
    });
  }

  /**
   * 
   * @param vm 
   * @returns 
   */
  private requestFormVm(vm: IContentViewModel): IRequestEntryFormViewModel {
    const data: IVehicleRequestData = this.testData();

    const ret: IRequestEntryFormViewModel = {
      ...super.formVm('vehicle-request', { okCancelOptions: {} }),

      data: data,

      resNumberInputVm: FormInputComponent.viewModel(data, 'resNumber',
        { title: 'Res Number', isRequired: false }),
      pickupDateInputVm: FormInputComponent.viewModel(data, 'pickupDate',
        { title: 'Pickup Date', isRequired: true, type: 'date' }),
      pickupTimeInputVm: FormInputComponent.viewModel(data, 'pickupTime',
        { title: 'Pickup Time', isRequired: true, type: 'time' }),
      serviceAreaAutoCompleteVm: FormAutoCompleteComponent.viewModel(data, 'serviceArea',
        { title: 'Service Area', apiPath: this.apiPath, apiAction: 'auto-complete-service-area' }),
      customerCodeAutoCompleteVm: FormAutoCompleteComponent.viewModel(data, 'customerCode',
        { title: 'Customer', apiPath: this.apiPath, apiAction: 'auto-complete-customer' }),
      passengerCodeAutoCompleteVm: FormAutoCompleteComponent.viewModel(data, 'passengerCode',
        { title: 'Passengers', apiPath: this.apiPath, apiAction: 'auto-complete-passenger' }),
      vehicleTypeAutoCompleteVm: FormAutoCompleteComponent.viewModel(data, 'vehicleType',
        { title: 'Vehicle Type', apiPath: this.apiPath, apiAction: 'auto-complete-vehicle-type' }),
      pickupLocationInputVm: FormInputComponent.viewModel(data, 'pickupLocation',
        { title: 'Pickup Location', isRequired: true }),
      dropLocationInputVm: FormInputComponent.viewModel(data, 'dropLocation',
        { title: 'Drop-off Location', isRequired: true }),
      bookerNameInputVm: FormInputComponent.viewModel(data, 'bookerName',
        { title: 'Booker Name', isRequired: true }),
      bookerPhoneInputVm: FormInputComponent.viewModel(data, 'bookerPhone',
        { title: 'Booker Phone', isRequired: true }),
      commentsInputVm: FormInputComponent.viewModel(data, 'comments',
        { title: 'Comments', isRequired: false, type: 'textarea' })
    };

    this.requestFormValidate(vm, ret);

    return ret;
  }

  /**
   * 
   * @param vm 
   * @param fvm 
   */
  requestFormValidate(vm: IContentViewModel, fvm: IRequestEntryFormViewModel) {
    const valids = [
      !fvm.data.serviceArea ? false : true,
      !fvm.data.customerCode ? false : true,
      !fvm.data.vehicleType ? false : true,
      !fvm.data.pickupLocation ? false : true,
      !fvm.data.dropLocation ? false : true,
      !fvm.data.pickupDate ? false : true,
      !fvm.data.pickupTime ? false : true
    ];
    fvm.isValid = valids.filter(v => !v).length == 0;
  }

  /**
   * 
   * @param pvm 
   * @param vm 
   * @param fvm 
   */
  async requestFormOk(pvm: IPageViewModel, vm: IContentViewModel, fvm: IRequestEntryFormViewModel) {

    const success = await FormOkCancelComponent.processOkAsync(fvm.okCancelVm, 'Submitting...',
      () => this.vehicleRequestCommandInvoke('submit', fvm.data));

    if (success)
      this.formEndRefresh(pvm);
  }

  //#endregion request form

  /**
   * 
   */
  ngOnInit(): void {
    super.onInit((arg: IBasePageOnInitArg) => {

      // vehicle request page
      if (arg.oneTimeInfo) {
        console.log('ngOnInit');
        console.log(arg);
        return of({}).pipe(
          switchMap(() => merge(
            of({ workingText: arg.oneTimeInfo.workflowItemStatus == '20' ? 'Approving...' : arg.oneTimeInfo.workflowItemStatus == '21' ? 'Rejecting...' : 'Loading...' }),
            of({}).pipe(
              switchMap(() => {
                return arg.oneTimeInfo.workflowItemStatus == '20' ? this.vehicleRequestCommandInvoke('vehicle-request-accept', { accessToken: arg.oneTimeInfo.token })
                  : arg.oneTimeInfo.workflowItemStatus == '21' ? this.vehicleRequestCommandInvoke('vehicle-request-reject', { accessToken: arg.oneTimeInfo.token })
                  : of({ errorText: `Invalid status code '${arg.oneTimeInfo.workflowItemStatus}' for token '${arg.oneTimeInfo.token}'` })
              })
            )
          )),

          map((pd: IPageDataViewModel) => {
            console.log('map1');
            if (pd.workingText || pd.errorText)
              return pd;

            const contentVm: IContentViewModel = {
              vehicleRequestResponseVm: {
                token: arg.oneTimeInfo.token,
                workflowItemStatus: arg.oneTimeInfo.workflowItemStatus == '20' ? 'Approved' : arg.oneTimeInfo.workflowItemStatus == '21' ? 'Rejected' : 'Unknown',

                data: pd.data.requestData
              }
            }

            const ret: IPageDataViewModel = {
              contentVm: contentVm
            }
            return ret;
          })

        );
      }

      // user page
      return of({}).pipe(

        // load content VM
        switchMap(() => this.vehicleRequestCommandInvoke('page-load', {})),

        // return page VM
        map((pd: IPageDataViewModel) => {
          console.log('map2');
          if (pd.workingText || pd.errorText)
            return pd;

          const ret: IPageDataViewModel = {
            ...pd,

            contentVm: this.contentViewModel(arg, pd.data)
          };
          return ret;
        })
      );
    }, { canRefresh: true, canAddNew: true, canGoBack: true });
  }

  /**
   * 
   * @param pvm 
   * @param tvm
   * @param arg 
   */
  rowActionInvoke(pvm: IPageViewModel, tvm: IDataPanelTabViewModel,  arg: IDataTableRowActionClickArg) {
    this.workflowCompleteFormBegin(pvm, arg.actionCode, tvm.dataPanelVm.rowsFiltered.find(r => r.code == arg.rowCode));
  }

  /**
   * invoke the workflow action
   * @param fvm 
   * @param comment 
   * @returns 
   */
  protected workflowFormCompleteActionInvoke(fvm: IWorkflowCompleteFormViewModel, comment: string = undefined) : Observable<IPageDataViewModel> {
    return this.vehicleRequestCommandInvoke(fvm.actionCode, { entityCode: fvm.row.code, comment: comment });
  }

  /**
   * 
   * @returns 
   */
  private contentViewModel(arg: IBasePageOnInitArg, data: { groupedPanels: IViewData[] }): IContentViewModel {
    const vm: IContentViewModel = {
      tabVms: super.dataPanelTabVms(data.groupedPanels)
    };
    return vm;
  }

}

/**
 * 
 */
interface IContentViewModel extends IPageContentViewModel {
  tabVms?: IDataPanelTabViewModel[];

  vehicleRequestResponseVm?: IVehicleRequestResponseViewModel;
}

/**
 * 
 */
interface IVehicleRequestResponseViewModel {
  token: string;
  workflowItemStatus: string;

  data?: IVehicleRequestData;
}

/**
 * 
 */
interface IRequestEntryFormViewModel extends IPageContentFormViewModel {
  data: IVehicleRequestData;

  resNumberInputVm?: IFormInputViewModel;
  pickupDateInputVm: IFormInputViewModel;
  pickupTimeInputVm: IFormInputViewModel;
  serviceAreaAutoCompleteVm?: IFormAutoCompleteViewModel;
  customerCodeAutoCompleteVm?: IFormAutoCompleteViewModel;
  passengerCodeAutoCompleteVm?: IFormAutoCompleteViewModel;
  vehicleTypeAutoCompleteVm?: IFormAutoCompleteViewModel;
  pickupLocationInputVm: IFormInputViewModel;
  dropLocationInputVm: IFormInputViewModel;
  bookerNameInputVm: IFormInputViewModel;
  bookerPhoneInputVm: IFormInputViewModel;
  commentsInputVm: IFormInputViewModel;
}

/**
 * 
 */
interface IDetailFormViewModel extends IPageContentFormViewModel {
  title: string;

  entryVm?: {
    data: {};
    entryInputVm: IFormInputViewModel;
  }
}

/**
 * 
 */
interface IVehicleRequestData {
  resNumber?: string;
  pickupDate?: string;
  pickupTime?: string;
  serviceArea?: string;
  customerCode?: string;
  passengerCode?: string;
  vehicleType?: string;
  pickupLocation?: string;
  dropLocation?: string;
  bookerName?: string;
  bookerPhone?: string;
  comments?: string;
}
